import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import { softwareAndAppsMenus } from "../data/software-apps";
import { useScrollTop } from "../hook/useScrollTop";
import AgileDevelopmentTeam from "../sections/agile-development-team";
import CloudEngineering from "../sections/cloud-engineering";
import Consultancy from "../sections/consultancy";
import DigitalProductDesign from "../sections/digital-product-design";
import MobileDevelopment from "../sections/mobile-development";
import QualityAssurace from "../sections/quality-assurace";
import SoftwareArchitecture from "../sections/software-architecture";
import WebDevelopment from "../sections/web-development";

import SubscribeContact from "../components/subscribeContact";
import TableOfContents from "../components/table-of-contents";
import bannerImage from "../images/software-and-apps/software-and-apps-banner.jpg";

const SoftwareApps = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Software Apps</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={bannerImage}>
        <div className="pt-7 pb-5 text-center container">
          <p className="d-inline-block py-3 px-5 fs-14 border-yellow gilroy-bold mt-5 dm-header-btn text-uppercase">
            A ONE-STOP-SHOP DEVELOPMENT PARTNER
          </p>
          <h1 className="fs-56 lh-64 py-5 text-capitalize flex align-items-center fw-900">
            Custom software development services from professionals you'll enjoy
            working with
          </h1>
          <p className="fs-16 lh-30 mx-0 mx-md-5 px-0 px-md-5">
            Team up with superstar product designers, frontend/backend
            developers, cloud architects, and DevOps. 170+ professionals. 140+
            delivered projects. Full-cycle custom software development services
            powered by 9 years of best practices.
          </p>
        </div>
      </Header>
      <section className="d-none d-md-block position-sticky top-0 w-100">
        <ul className="d-flex justify-content-around fs-14 text-center p-0 m-0 align-items-stretch">
          {softwareAndAppsMenus.map((menu, index) => (
            <li
              key={index}
              className="list-style-none submenu-link border-gray w-100 d-flex align-items-center justify-content-center"
            >
              <a
                href={menu.link}
                className="text-decoration-none gilroy-bold d-block py-3"
              >
                {menu.label}
              </a>
            </li>
          ))}
        </ul>
      </section>
      <TableOfContents routes={softwareAndAppsMenus} />
      <section>
        <section className="">
          <div className="me-35 ms-35 pt-7 pb-7">
            <DigitalProductDesign />
          </div>

          <div
            className=""
            style={{
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            }}
          >
            <div className="me-35 ms-35 pt-7 pb-7">
              <AgileDevelopmentTeam />
            </div>
          </div>

          <div className="me-35 ms-35 pt-7 pb-7">
            <CloudEngineering />
          </div>

          <div
            className=""
            style={{
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            }}
          >
            <div className="me-35 ms-35 pt-7 pb-7">
              <SoftwareArchitecture />
            </div>
          </div>

          <div className="me-35 ms-35 pt-7 pb-7">
            <WebDevelopment />
          </div>

          <div
            className=""
            style={{
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            }}
          >
            <div className="me-35 ms-35 pt-7 pb-7">
              <MobileDevelopment />
            </div>
          </div>

          <div className="me-35 ms-35 pt-7 pb-7">
            <QualityAssurace />
          </div>

          <div
            className=""
            style={{
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            }}
          >
            <div className="me-35 ms-35 pt-7 pb-7">
              <Consultancy />
            </div>
          </div>
        </section>
      </section>
      <SubscribeContact />
      <Footer />
    </>
  );
};

export default SoftwareApps;
